import { Record } from 'immutable'

export class CostType extends Record({
    id: undefined,
    name: undefined,
}) {}
